<template>
  <validation-form @on-submit="report">
    <div class="md-card">
      <div class="md-card-content">
        <div class="md-layout">
          <div class="md-layout-item md-size-100 p-0">
            <p>{{ $t("extended_exportation.select_program") }}</p>
          </div>
          <div class="md-layout-item md-size-100 md-layout p-0">
            <div class="md-layout-item md-size-33 md-small-size-100 p-0">
              <validation-field
                :validations="{ required: true }"
                name="program"
              >
                <label>{{ $t("common.program") }}</label>
                <md-select v-model="reportData.program_id" required>
                  <md-option
                    v-for="(program, idx) in programList"
                    :value="program.id"
                    :key="'program' + idx"
                    >{{ program.name }}</md-option
                  >
                </md-select>
              </validation-field>
            </div>
          </div>
          <div class="md-layout-item md-size-100 p-0">
            <p>{{ $t("extended_exportation.select_student") }}</p>
          </div>
          <div class="md-layout-item md-size-100 md-layout p-0">
            <div class="md-layout-item md-size-33 pl-0">
              <validation-field :validations="{ required: true }" name="term">
                <label>{{ $t("class.term") }}</label>
                <md-select v-model="reportData.term_id" name="term" required>
                  <md-option
                    v-for="(term, idx) in termList"
                    :value="term.id"
                    :key="'term' + idx"
                    >{{ term.name }}</md-option
                  >
                </md-select>
              </validation-field>
            </div>
            <div class="md-layout-item md-size-33">
              <validation-field
                :validations="{ required: true }"
                name="class"
                type="multi-select"
              >
                <template #default="{ errors }">
                  <label class="checkbox-label"
                    >{{ $t("common.class") }}
                    <span style="color:#F44336">*</span></label
                  >
                  <checkbox-multi-select
                    :options="classList"
                    trackBy="id"
                    displayField="name"
                    v-model="reportData.class_ids"
                    :style="{ marginTop: '-10px' }"
                    :class="{ 'md-invalid': !!errors.length }"
                    @filtering="debounceSearchKey({ class_name: $event.text })"
                    @select="selectItem"
                    @open="getClassList()"
                    @removed="removedItem"
                  >
                  </checkbox-multi-select>
                  <span class="md-error class-required"> {{ errors[0] }}</span>
                </template>
              </validation-field>
            </div>
            <div class="md-layout-item md-size-33">
              <validation-field
                :validations="{ required: true }"
                name="school year"
                type="multi-select"
              >
                <template #default="{ errors }">
                  <label class="checkbox-label"
                    >{{ $t("extended_exportation.entered_school_year") }}
                    <span style="color:#F44336">*</span></label
                  >
                  <checkbox-multi-select
                    :showSelectAll="true"
                    :options="schoolYearList"
                    trackBy="school_year"
                    displayField="school_year"
                    v-model="reportData.start_years"
                    :style="{ marginTop: '-10px' }"
                    :class="{ 'md-invalid': !!errors.length }"
                  >
                  </checkbox-multi-select>
                  <span class="md-error class-required"> {{ errors[0] }}</span>
                </template>
              </validation-field>
            </div>
            <div class="md-layout-item md-size-33 pl-0">
              <validation-field
                :validations="{ required: true }"
                name="grade"
                type="multi-select"
              >
                <template #default="{ errors }">
                  <label class="checkbox-label"
                    >{{ $t("common.grade") }}
                    <span style="color:#F44336">*</span></label
                  >
                  <checkbox-multi-select
                    :showSelectAll="true"
                    :options="gradeList"
                    trackBy="id"
                    displayField="name"
                    v-model="reportData.grade_names"
                    :style="{ marginTop: '-10px' }"
                    :class="{ 'md-invalid': !!errors.length }"
                  >
                  </checkbox-multi-select>
                  <span class="md-error class-required"> {{ errors[0] }}</span>
                </template>
              </validation-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center">
      <md-button class="md-warning" type="submit">{{
        $t("common.report")
      }}</md-button>
    </div>
  </validation-form>
</template>
<script>
import { service_names, service_paths } from "@/constants/Services";
import { getId, Message } from "@/helpers/utils";
import debounce from "lodash/debounce";
import CheckboxMultiSelect from "@/components/Base/CheckboxMultiSelect";

export default {
  components: {
    CheckboxMultiSelect
  },
  data() {
    return {
      reportData: {
        program_id: "",
        term_id: "",
        class_ids: [],
        start_years: [],
        grade_names: []
      },
      programList: [],
      termList: [],
      classList: [],
      schoolYearList: [],
      gradeList: [],
      selectedClasses: []
    };
  },
  created() {
    this.getProgramList();
    this.getTermList();
    this.getGradeList();
    this.getSchoolYearList();
  },
  computed: {
    debounceSearchKey() {
      return debounce(function(param) {
        this.getClassList(param);
      }, 500);
    }
  },
  methods: {
    getProgramList() {
      this.$axios
        .get(`${service_paths.programs}`, { limit: 50 })
        .then(({ data }) => {
          if (data) {
            this.programList = data.data.map(item => ({
              id: getId(item),
              name: item.name || ""
            }));
            this.reportData.program_id = getId(this.programList[0]);
          }
        });
    },
    getTermList() {
      this.$axios.get(service_paths.terms, { limit: 50 }).then(res => {
        this.termList = res.data.data.map(item => ({
          id: getId(item),
          name: item.name || ""
        }));
        this.reportData.term_id = getId(this.termList[0]);
      });
    },
    getClassList(param) {
      return this.$axios
        .get(`${service_paths.classes}/${this.reportData.term_id}/term`, {
          ...param,
          limit: 50
        })
        .then(response => {
          let result = response.data.data
            .filter(item => !this.reportData.class_ids.includes(getId(item)))
            .map(item => ({
              id: getId(item),
              name: item.name
            }));
          this.classList = [...this.selectedClasses, ...result];
        });
    },
    getSchoolYearList() {
      this.$axios
        .get(`${service_names.user}/school-years`, {
          order_by: "school_year ASC"
        })
        .then(response => {
          this.schoolYearList = response.data.data;
          this.reportData.start_years = this.schoolYearList.map(
            item => item.school_year
          );
        });
    },
    getGradeList() {
      this.$axios
        .get(`${service_names.school}/grades`, { limit: 30 })
        .then(response => {
          this.gradeList = response.data.data.map(item => ({
            id: item.name,
            name: item.name || ""
          }));
          this.reportData.grade_names = this.gradeList.map(item => getId(item));
        });
    },
    report() {
      this.$axios
        .get(
          `${service_paths.export}/graduation/tracker`,
          this.reportData,
          undefined,
          undefined,
          "blob"
        )
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "graduation_tracker.pdf");
          document.body.appendChild(link);
          link.click();
          link.remove();
          Message.success(this.$t("common.export_success"));
        });
    },
    selectItem(event) {
      this.selectedClasses.push(event.itemData);
      this.reportData.class_ids = this.selectedClasses.map(item => {
        return item.id;
      });
    },
    removedItem(event) {
      this.selectedClasses = this.selectedClasses.filter(
        item => item.id !== event.itemData?.id
      );
      this.reportData.class_ids = this.selectedClasses.map(item => {
        return item.id;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.class-required {
  color: #ff1744;
  font-size: 12px;
  top: -4px !important;
  position: relative;
}
.checkbox-label {
  font-size: 11px;
  font-weight: 400;
  color: #aaaaaa !important;
  line-height: 1.4;
}
</style>
